import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 68 — HubSpot cluster (second set) service links.
 *
 * Every Batch 68 article routes its primary commercial link to
 * /hubspot-revops-architect. The answer-first leads in batch68Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /hubspot-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH68_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hubspot-for-ecommerce-companies": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no win-back flow is a portal the team runs on a revenue report/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-abm-account-based-marketing-setup": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no committee list is a portal the sales team runs on a single contact/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-operations-hub-setup-guide": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no dedup rule is a portal the team runs on duplicates/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-form-automation-lead-capture": {
    url: "/hubspot-revops-architect",
    anchor: /portal with no UTM capture is a portal the team runs on a guess/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-playbooks-sales-enablement-setup": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal with no coaching review is a portal the rep runs on the guide alone/i,
    label: "hire a HubSpot RevOps architect",
  },
};
